var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { container, injectable } from 'tsyringe';
var ChristmasService = /** @class */ (function () {
    function ChristmasService() {
        this.flakes = [];
        this.dashboardJobibot = 'xmas-jobilla-dashboard';
        this.textJobibot = 'xmas-jobibot-text';
        this.jobibot = 'xmas-jobibot';
        this.snowfallInterval = null;
        this.snowing = false;
    }
    Object.defineProperty(ChristmasService.prototype, "canvas", {
        get: function () {
            return container.resolve('appCanvas');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ChristmasService.prototype, "ctx", {
        get: function () {
            var _a;
            return (_a = this.canvas) === null || _a === void 0 ? void 0 : _a.getContext('2d');
        },
        enumerable: false,
        configurable: true
    });
    ChristmasService.applicable = function () {
        return new Date().getMonth() === 11;
    };
    ChristmasService.prototype.applyScreenEffect = function () {
        var _this = this;
        if (this.snowing === true) {
            return;
        }
        this.snowing = true;
        this.snowfallInterval = setInterval(function () {
            _this.letItSnow();
        }, 30);
    };
    ChristmasService.prototype.cancelScreenEffect = function () {
        clearInterval(this.snowfallInterval);
    };
    ChristmasService.prototype.letItSnow = function () {
        if (!this.canvas || !this.ctx) {
            // eslint-disable-next-line no-console
            return console.warn('Christmas canvas not found :( Cannot provide festive spirit');
        }
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.addFlake();
        this.snow();
    };
    ChristmasService.prototype.addFlake = function () {
        var x = Math.ceil(Math.random() * this.canvas.width);
        var s = Math.ceil(Math.random() * 4);
        this.flakes.push({ x: x, y: 0, s: s });
    };
    ChristmasService.prototype.snow = function () {
        var _this = this;
        this.flakes.forEach(function (flake, index) {
            _this.ctx.beginPath();
            _this.ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
            _this.ctx.arc(flake.x, flake.y += flake.s / 3, flake.s / 3, 0, 2 * Math.PI);
            _this.ctx.fill();
            if (flake.y > _this.canvas.height) {
                _this.flakes.splice(index, 1);
            }
        });
    };
    ChristmasService = __decorate([
        injectable()
    ], ChristmasService);
    return ChristmasService;
}());
export { ChristmasService };
